// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.photo-list-container {
  width: 100%;
  height: auto;
  justify-content: center;
  display: flex;
  margin-bottom: 20px;
  padding-top: 60px;
}

.wizard-container {
  width: 100%;
  height: 100%;
}

.photo-container {
  height: 288px;
  width: 216px;
}

.photo-container img {
  border: black 1px solid;
  height: 100%;
  width: 100%;
}

.chip {
  margin-left: 0px;
}

.portrait {
  margin-left: 10px;
}

.command-panel {
  display: flex;
  justify-content: center;
  width: 100%;
}

.command-panel button {
  width: 220px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 2px;
}

.ph_comp_no_photo {
  width: 100%;
  height: 100%;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  background: url('no_photo_placeholder.8c0735f8a2d17bb9.svg') center/70% no-repeat;
  background-position: 50%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  background-position-y: 50%;
  margin-right: 10px;
  border-radius: 10px;
}

.ph_comp_true_photo {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  margin-right: 10px;
  width: 100%;
  border-radius: 10px;
  background-size: cover;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.ph_comp-info {
  background: none;
  border-bottom: none;
  padding: 5px;
  text-align: center;
  margin: 0;
  border-radius: 10px 10px 0 0;
}

.ph_comp_no_photo-info {
  background: white;
  border-bottom: 2px dashed;
  padding: 5px;
  text-align: center;
  margin: 0;
  border-radius: 10px 10px 0 0;
}

.ph_comp_no_photo-alert {
  background: #f9cccc;
  margin-bottom: 0 !important;
  border-radius: 0 0 10px 10px;
  padding: 8px;
  font-weight: 900;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/dev/photo/photo.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AACJ;;AACA;EACI,WAAA;EACA,YAAA;AAEJ;;AAAA;EACI,aAAA;EACA,YAAA;AAGJ;;AADA;EACI,uBAAA;EACA,YAAA;EACA,WAAA;AAIJ;;AAFA;EACI,gBAAA;AAKJ;;AAHA;EACI,iBAAA;AAMJ;;AAJA;EACI,aAAA;EACA,uBAAA;EACA,WAAA;AAOJ;;AALA;EACI,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAQJ;;AANA;EACI,WAAA;EACA,YAAA;EACA,yHAAA;EACA,iFAAA;EACA,wBAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;AASJ;;AAPA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,yHAAA;AAUJ;;AARA;EACI,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,4BAAA;AAWJ;;AATA;EACI,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,4BAAA;AAYJ;;AAVA;EACI,mBAAA;EACA,2BAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;AAaJ","sourcesContent":[".photo-list-container {\n    width: 100%;\n    height: auto;\n    justify-content: center;\n    display: flex;\n    margin-bottom: 20px;\n    padding-top: 60px;\n}\n.wizard-container {\n    width: 100%;\n    height: 100%;\n}\n.photo-container {\n    height: 288px;\n    width: 216px;\n}\n.photo-container img {\n    border: black 1px solid;\n    height: 100%;\n    width: 100%;\n}\n.chip {\n    margin-left: 0px;\n}\n.portrait {\n    margin-left: 10px;\n}\n.command-panel {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n}\n.command-panel button {\n    width: 220px;\n    margin-bottom: 10px;\n    margin-left: 5px;\n    margin-right: 2px;\n}\n.ph_comp_no_photo {\n    width: 100%;\n    height: 100%;\n    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);\n    background: url(../../../assets/images/no_photo_placeholder.svg) center/70% no-repeat;\n    background-position: 50%;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    background-position-y: 50%;\n    margin-right: 10px;\n    border-radius: 10px;\n}\n.ph_comp_true_photo {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: space-between;\n    margin-right: 10px;\n    width: 100%;\n    border-radius: 10px;\n    background-size: cover;\n    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);\n}\n.ph_comp-info {\n    background: none;\n    border-bottom: none;\n    padding: 5px;\n    text-align: center;\n    margin: 0;\n    border-radius: 10px 10px 0 0;\n}\n.ph_comp_no_photo-info {\n    background: white;\n    border-bottom: 2px dashed;\n    padding: 5px;\n    text-align: center;\n    margin: 0;\n    border-radius: 10px 10px 0 0;\n}\n.ph_comp_no_photo-alert {\n    background: #f9cccc;\n    margin-bottom: 0!important;\n    border-radius: 0 0 10px 10px;\n    padding: 8px;\n    font-weight: 900;\n    margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
